import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { X, Download, Copy, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const SpotlightModal = ({ person, headers, onClose }) => {
  const [meta, setMeta] = useState(null);
  const [caption, setCaption] = useState('');
  useEffect(() => {
    axios.get(`${API}/api/admin/super/converge/speakers/${person.id}/spotlight`, { headers })
      .then((r) => { setMeta(r.data); setCaption(r.data.caption); })
      .catch(() => toast.error('Could not load spotlight'));
  }, [person.id]); // eslint-disable-line

  const shareUrl = meta ? `${API}${meta.share_path}` : '';
  const copy = async (text, label) => {
    try { await navigator.clipboard.writeText(text); toast.success(`${label} copied`); } catch { window.prompt(`Copy ${label}:`, text); }
  };
  const download = async () => {
    let res;
    try { res = await axios.get(`${API}${meta.card_path}`, { responseType: 'blob' }); } catch { toast.error('Could not download the card'); return; }
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `converge-spotlight-${person.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}.png`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  const btn = 'inline-flex items-center gap-1.5 px-3 py-2 rounded text-sm font-semibold';

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="spotlight-modal">
      <div className="bg-white text-gray-900 w-full max-w-2xl rounded-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <h4 className="font-bold text-gray-900">Spotlight post — {person.name}</h4>
          <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-800" aria-label="Close" data-testid="spotlight-close-btn"><X size={18} /></button>
        </div>
        {!meta ? <div className="flex justify-center py-16"><Loader2 className="animate-spin text-gray-400" /></div> : (
          <div className="p-5 space-y-4">
            <img src={`${API}${meta.card_path}?t=${Date.now()}`} alt={`Spotlight card for ${person.name}`} className="w-full border rounded" data-testid="spotlight-card-img" />
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Caption (edit before sharing)</label>
              <textarea value={caption} onChange={(e) => setCaption(e.target.value)} className="w-full h-36 px-3 py-2 border border-gray-300 rounded text-sm" data-testid="spotlight-caption" />
            </div>
            <div className="flex flex-wrap gap-2">
              <button onClick={download} className={`${btn} bg-gray-900 text-white`} data-testid="spotlight-download-btn"><Download size={14} /> Download card</button>
              <button onClick={() => copy(`${caption}\n\n${shareUrl}`, 'Caption')} className={`${btn} bg-gray-100`} data-testid="spotlight-copy-caption-btn"><Copy size={14} /> Copy caption + link</button>
              <a href={`https://wa.me/?text=${encodeURIComponent(`${caption}\n\n${shareUrl}`)}`} target="_blank" rel="noopener noreferrer" className={`${btn} bg-[#25D366] text-white`} data-testid="spotlight-whatsapp-link">Share on WhatsApp</a>
              <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" onClick={() => copy(caption, 'Caption')} className={`${btn} bg-[#0A66C2] text-white`} data-testid="spotlight-linkedin-link">Share on LinkedIn</a>
            </div>
            <p className="text-xs text-gray-500">LinkedIn doesn't accept pre-filled text, so the caption is copied for you to paste. The shared link shows this card as its preview.</p>
          </div>
        )}
      </div>
    </div>
  );
};
